import { render, staticRenderFns } from "./EditActivityLabourerWorkplacePage.vue?vue&type=template&id=29acb21a&"
import script from "./EditActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./EditActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports